import reducer, { fetchUser, updateDevice } from './account.reducer';

export { fetchUser, updateDevice };
export default reducer;
